import React, { useEffect, useState, Suspense, useContext } from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";

import "./Attendance/i18n";

// App Context
import AppContext from "../store/App/contexts";

// Layout Component
import Layout from "../components/Layout";

// Pages
import ART from "./ART";
import Login from "./Login";
import ForgotPassword from "./ForgotPassword";
import Home from "./Home";
import SmartScheduler from "./SmartScheduler";
// import CancelShift from './CancelShift'
import UploadProof from "./UploadProof";
import NotificationsList from "./NotificationsList";
import NotificationDetail from "./NotificationDetail";
import UserProfile from "./UserProfile";
import EditProfile from "./EditProfile";
import Setting from "./Setting";
import ChangePassword from "./ChangePassword";
import ChooseLanguage from "./ChooseLanguage";
import Rewards from "./Rewards";
import Cart from "./Rewards/Cart";
import CartDetail from "./Rewards/CartDetail";
import ItemDetail from "./Rewards/ItemDetail";
import TransactionHistory from "./Rewards/TransactionHistory";
import Events from "./Events";
import EventDetail from "./Events/EventDetail";
import EDocs from "./EDocs";
import Attendance from "./Attendance";
import Communications from "./Communications";
import FeedbackAdd from "../components/Communications/Feedback/FeedbackAdd";
import FeedbackView from "../components/Communications/Feedback/FeedbackView";
import InstructionDetail from "./Communications/InstructionDetail";
import FAQ from "./FAQ";
import Leave from "./Leave";
import LeaveApply from "../components/Leave/LeaveApply";
import LeaveView from "../components/Leave/LeaveView";
import LeaveEntitlement from "../components/Leave/LeaveEntitlement";
import Claims from "./Claims";
import ClaimsAdd from "../components/Claims/ClaimsAdd";
import ClaimsUpdate from "../components/Claims/ClaimsUpdate";
import ThankyouPage from "./ThankyouPage";
import Catalogue from "./Catalogue";
import CatalogueDetail from "./Catalogue/CatalogueDetail";
import DeliveryOrder from "./DeliveryOrder";
import DeliveryOrderCollect from "./DeliveryOrder/Collect";
import TimeClock from "./TimeClock";
import TimeClockThankyouPage from "../components/TimeClock/ClockInOut/ThankyouPage";
import SchedulePreference from "../components/TimeClock/SchedulePreference";
import SiteSettings from "../components/SiteSettings";

import ToastNotification from "../components/ToastNotification";
import { newFetch, GET } from "../helpers/fetch";
import { changeStartOfWeek } from "../helpers/moment";
import Modal from "../components/Modal";

const ManpowerAssociate = () => {
  const { isLoggedIn, logoutHandler } = useContext(AppContext);
  const user = JSON.parse(localStorage.getItem("user"));
  const clientID = user?.site_associates?.[0]?.site?.client_id ?? null;

  const token = localStorage.getItem("token")
    ? localStorage.getItem("token")
    : null;

  const [client, setClient] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const fetchClient = async (id) => {
    let api_path = `/client/${id}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setClient(response.data);
      changeStartOfWeek(response.data.start_day);
    }
  };

  const closeModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    if (clientID) {
      fetchClient(clientID);
    }
  }, [clientID]);

  return (
    <AppContext.Consumer>
      {({ isLoggedIn, logoutHandler }) => (
        <Router>
          <ToastNotification />
          <Switch>
            <Route
              path="/"
              exact
              render={() => {
                return !isLoggedIn ? (
                  <Redirect to="/login" />
                ) : (
                  <Layout>
                    <Home />
                  </Layout>
                );
              }}
            />

            <Route
              path="/login"
              exact
              component={() => {
                return isLoggedIn ? <Redirect to="/" /> : <Login />;
              }}
            />

            <Route path="/client/site/:id">
              <Suspense fallback={<div>Loading</div>}>
                <Attendance />
              </Suspense>
            </Route>

            <Route path="/forgot-password" exact component={ForgotPassword} />

            <Route
              path="/logout"
              exact
              component={() => {
                logoutHandler();
                return <Redirect to="/" />;
              }}
            />

            {isLoggedIn ? (
              <>
                <Route
                  path="/scheduler"
                  exact
                  render={(props) => (
                    <Layout>
                      <SmartScheduler {...props} />
                    </Layout>
                  )}
                />
                <Route
                  path="/time-clock"
                  exact
                  render={(props) => (
                    <Layout>
                      <TimeClock {...props} />
                    </Layout>
                  )}
                />
                <Route
                  path="/thank-you"
                  exact
                  render={(props) => (
                    <Layout>
                      <TimeClockThankyouPage {...props} />
                    </Layout>
                  )}
                />
                <Route
                  path="/preferred-schedule"
                  exact
                  render={(props) => (
                    <Layout>
                      <SchedulePreference {...props} />
                    </Layout>
                  )}
                />
                <Route
                  path="/site-settings"
                  exact
                  render={(props) => (
                    <Layout>
                      <SiteSettings {...props} />
                    </Layout>
                  )}
                />
                {/* <Route
                  path="/cancel/:schedule_id"
                  exact
                  render={(props) => (
                    <Layout>
                      <CancelShift {...props} />
                    </Layout>
                  )}
                /> */}

                <Route
                  path="/upload-proof/:schedule_id"
                  exact
                  render={(props) => (
                    <Layout>
                      <UploadProof {...props} />
                    </Layout>
                  )}
                />

                <Route
                  path="/notifications"
                  exact
                  render={(props) => (
                    <Layout>
                      <NotificationsList {...props} />
                    </Layout>
                  )}
                />

                <Route
                  path="/notifications/:id"
                  exact
                  render={(props) => (
                    <Layout>
                      <NotificationDetail {...props} />
                    </Layout>
                  )}
                />

                <Route
                  path="/profile"
                  exact
                  render={(props) => (
                    <Layout>
                      <UserProfile {...props} />
                    </Layout>
                  )}
                />

                <Route
                  path="/profile/edit"
                  exact
                  render={(props) => (
                    <Layout>
                      <EditProfile {...props} />
                    </Layout>
                  )}
                />

                <Route
                  path="/setting"
                  exact
                  render={(props) => (
                    <Layout>
                      <Setting {...props} />
                    </Layout>
                  )}
                />

                <Route
                  path="/chooseLanguage"
                  exact
                  render={(props) => (
                    <Layout>
                      <ChooseLanguage {...props} />
                    </Layout>
                  )}
                />

                <Route
                  path="/changePassword"
                  exact
                  render={(props) => (
                    <Layout>
                      <ChangePassword {...props} />
                    </Layout>
                  )}
                />

                {client && client.enable_catalogue && (
                  <>
                    <Route
                      path="/catalogue"
                      exact
                      render={(props) => (
                        <Layout>
                          <Catalogue {...props} />
                        </Layout>
                      )}
                    />

                    <Route
                      path="/catalogue/:catalogue_id"
                      exact
                      render={(props) => (
                        <Layout>
                          <CatalogueDetail {...props} />
                        </Layout>
                      )}
                    />
                  </>
                )}

                <Route
                  path="/delivery-order"
                  exact
                  render={(props) => (
                    <Layout>
                      <DeliveryOrder {...props} />
                    </Layout>
                  )}
                />

                <Route
                  path="/delivery-order/collect/:id"
                  exact
                  render={(props) => (
                    <Layout>
                      <DeliveryOrderCollect {...props} />
                    </Layout>
                  )}
                />

                {client && client.enable_leave_credits && (
                  <>
                    <Route
                      path="/leave"
                      exact
                      render={(props) => (
                        <Layout>
                          <Leave {...props} />
                        </Layout>
                      )}
                    />
                    <Route
                      path="/leave-apply"
                      exact
                      render={(props) => (
                        <Layout>
                          <LeaveApply {...props} />
                        </Layout>
                      )}
                    />
                    <Route
                      path="/leave-view"
                      exact
                      render={(props) => (
                        <Layout>
                          <LeaveView {...props} />
                        </Layout>
                      )}
                    />
                    <Route
                      path="/leave-entitlement"
                      exact
                      render={(props) => (
                        <Layout>
                          <LeaveEntitlement {...props} />
                        </Layout>
                      )}
                    />
                  </>
                )}

                {client && client.enable_claims && (
                  <>
                    <Route
                      path="/claims"
                      exact
                      render={(props) => (
                        <Layout>
                          <Claims {...props} />
                        </Layout>
                      )}
                    />
                    <Route
                      path="/claimsadd"
                      exact
                      render={(props) => (
                        <Layout>
                          <ClaimsAdd {...props} />
                        </Layout>
                      )}
                    />
                    <Route
                      path="/claimsupdate"
                      exact
                      render={(props) => (
                        <Layout>
                          <ClaimsUpdate {...props} />
                        </Layout>
                      )}
                    />
                  </>
                )}

                {client && client.enable_reward && (
                  <>
                    <Route
                      path="/rewards"
                      exact
                      render={(props) => (
                        <Layout>
                          <Rewards {...props} />
                        </Layout>
                      )}
                    />

                    <Route
                      path="/rewards/cart"
                      exact
                      render={(props) => (
                        <Layout>
                          <Cart {...props} />
                        </Layout>
                      )}
                    />

                    <Route
                      path="/rewards/carts/:cart_id"
                      exact
                      render={(props) => (
                        <Layout>
                          <CartDetail {...props} />
                        </Layout>
                      )}
                    />

                    <Route
                      path="/rewards/item/:item_id"
                      exact
                      render={(props) => (
                        <Layout>
                          <ItemDetail {...props} />
                        </Layout>
                      )}
                    />

                    <Route
                      path="/rewards/transaction"
                      exact
                      render={(props) => (
                        <Layout>
                          <TransactionHistory {...props} />
                        </Layout>
                      )}
                    />
                  </>
                )}

                {client && client.enable_event && (
                  <>
                    <Route
                      path="/events"
                      exact
                      render={(props) => (
                        <Layout>
                          <Events {...props} />
                        </Layout>
                      )}
                    />

                    <Route
                      path="/events/event/:event_id"
                      exact
                      render={(props) => (
                        <Layout>
                          <EventDetail {...props} />
                        </Layout>
                      )}
                    />
                  </>
                )}
                <Route
                  path="/ART"
                  exact
                  render={(props) => (
                    <Layout>
                      <ART {...props} />
                    </Layout>
                  )}
                />

                {client && client.enable_edocs && (
                  <Route
                    path="/edocs"
                    exact
                    render={(props) => (
                      <Layout>
                        <EDocs {...props} />
                      </Layout>
                    )}
                  />
                )}

                {client && client.enable_communication && (
                  <>
                    <Route
                      path="/communications"
                      exact
                      render={(props) => (
                        <Layout>
                          <Communications {...props} />
                        </Layout>
                      )}
                    />
                    <Route
                      path="/communications/feedback/add"
                      exact
                      render={(props) => (
                        <Layout>
                          <FeedbackAdd {...props} />
                        </Layout>
                      )}
                    />
                    <Route
                      path="/communications/feedback/view"
                      exact
                      render={(props) => (
                        <Layout>
                          <FeedbackView {...props} />
                        </Layout>
                      )}
                    />
                    <Route
                      path="/communications/instructions/:instruction_id"
                      exact
                      render={(props) => (
                        <Layout>
                          <InstructionDetail {...props} />
                        </Layout>
                      )}
                    />
                  </>
                )}

                <Route
                  path="/faq"
                  exact
                  render={(props) => (
                    <Layout>
                      <FAQ {...props} />
                    </Layout>
                  )}
                />

                <Route
                  path="/thankyou"
                  exact
                  render={(props) => (
                    <Layout>
                      <ThankyouPage {...props} />
                    </Layout>
                  )}
                />
              </>
            ) : (
              <Redirect to="/logout" />
            )}
          </Switch>
          <Modal
            showModal={showModal}
            // customStyle={style}
            hideModal={closeModal}
          >
            <div className="h-100">
              <form
                className="d-flex flex-column justify-content-between flex-grow-1 mb-3"
                // onSubmit={(e) => submitHandler(e)}
              >
                <h5>Manage Shift</h5>
                <div className="mb-2">
                  <label htmlFor="shiftName">Shift Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="shiftName"
                    placeholder="Shift Name"
                    // value={shiftName}
                    // onChange={(e) => setShiftName(e.target.value)}
                  />
                </div>
              </form>
            </div>
          </Modal>
        </Router>
      )}
    </AppContext.Consumer>
  );
};

export default ManpowerAssociate;
